import { render, staticRenderFns } from "./ticket_category_language_codes.vue?vue&type=template&id=35b16da5&scoped=true&"
import script from "./ticket_category_language_codes.vue?vue&type=script&lang=js&"
export * from "./ticket_category_language_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b16da5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b16da5')) {
      api.createRecord('35b16da5', component.options)
    } else {
      api.reload('35b16da5', component.options)
    }
    module.hot.accept("./ticket_category_language_codes.vue?vue&type=template&id=35b16da5&scoped=true&", function () {
      api.rerender('35b16da5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_category_language_codes.vue"
export default component.exports